module.exports = __webpack_public_path__ + "static/media/bush.fe0fa752.png";